var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 5.566V20h2v-4h4v4h2V5.566l-4-2.4zM13 17v3h-2v-3zm9 4V9l-5 1.667V5l-5-3-5 3v4H2v12zm-5-9.28V20h4v-9.613zM7 10H3v10h4zm7-2V7h-4v1zm0 2v1h-4v-1zm0 4v-1h-4v1zM4 12h2v1H4zm16 3v-1h-2v1zM4 15h2v1H4zm16 3v-1h-2v1z",
    clipRule: "evenodd"
  })));
};
export default SvgCity;